import {
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { type FC, useCallback } from 'react';

import { useDeleteRouter, useOneRouter } from '../../api/index.js';
import DeleteDialog from '../DeleteDialog.js';

interface RouterDeleteProps {
  open: boolean;
  onClose: () => void;
  routerId?: string;
  refetch: () => void;
}
const RouterDelete: FC<RouterDeleteProps> = ({ open, onClose, routerId, refetch }) => {
  const { data } = useOneRouter(routerId!, {
    enabled: !!routerId,
  });

  const deleteMutation = useDeleteRouter();

  const onSubmit = useCallback(async () => {
    if (data?.id) {
      return deleteMutation.mutateAsync(data.id);
    }
  }, [data, deleteMutation]);

  return (
    <DeleteDialog
      open={open}
      name={'router'}
      onClose={onClose}
      onSubmit={onSubmit}
      refetch={refetch}
    >
      {data ? (
        <DialogContent>
          <List dense>
            <ListItem>
              <ListItemText primary={`Router Name: ${data.name}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`IMEI: ${data.imei}`} />
            </ListItem>
            <ListItem>
              <ListItemText primary={`IP Address: ${data.ipAddress}`} />
            </ListItem>
            {data.patient ? (
              <ListItem>
                <ListItemText primary={`Patient: ${data.patient.firstName} ${data.patient.lastName}`} />
              </ListItem>
            ) : null}
            {data.cameras?.length ? (
              <ListItem>
                <ListItemText primary={`Cameras: ${data.cameras.map((camera) => camera.name).join(', ')}`} />
              </ListItem>
            ) : null}
          </List>
        </DialogContent>
      ) : null}
    </DeleteDialog>
  );
};

export default RouterDelete;
